export interface DropdownOptions {
  label: string;
  value: string;
}
